import { Box, Grid, MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField } from '../../../common';
import { SOURCE_TYPE_LABELS } from '../constants/supplyOrdersConstants';
import { getProviderDisplayLabel } from '../utils/supplyOrdersUtils';
import SupplyOrderMaterialsSection from './SupplyOrderMaterialsSection';

const SupplyOrderFormSection = ({
  selectedOrder,
  onInputChange,
  onSelectChange,
  warehouses = [],
  warehousesLoading = false,
  providers = [],
  providersLoading = false,
  searchEnabled = true,
  onAddMaterial,
  onUpdateMaterialQuantity,
  onRemoveMaterial,
  isMobile = false,
  providerOnly = false,
}) => {
  const isProviderSource = providerOnly || selectedOrder.source_type === 'provider';
  const isWarehouseSource = !providerOnly && selectedOrder.source_type === 'warehouse';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Grid container spacing={2}>
        {!providerOnly && (
          <Grid item xs={12} md={4}>
            <CustomSelect
              label="Tipo de origen"
              name="source_type"
              value={selectedOrder.source_type}
              onChange={onSelectChange}
              fullWidth
            >
              {Object.entries(SOURCE_TYPE_LABELS).map(([value, label]) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
        )}

        {isProviderSource && (
          <Grid item xs={12} md={providerOnly ? 6 : 4}>
            <CustomSelect
              label="Proveedor"
              name="uuid_provider_legal_entity"
              value={selectedOrder.uuid_provider_legal_entity}
              onChange={onSelectChange}
              disabled={providersLoading}
              fullWidth
            >
              {providersLoading ? (
                <MenuItem value="" disabled>
                  Cargando proveedores...
                </MenuItem>
              ) : null}
              {providers.map((provider) => (
                <MenuItem key={provider.uuid} value={provider.uuid}>
                  {getProviderDisplayLabel(provider)}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
        )}

        {isWarehouseSource && (
          <Grid item xs={12} md={4}>
            <CustomSelect
              label="Depósito origen"
              name="uuid_source_warehouse"
              value={selectedOrder.uuid_source_warehouse}
              onChange={onSelectChange}
              disabled={warehousesLoading}
              fullWidth
            >
              {warehousesLoading ? (
                <MenuItem value="" disabled>
                  Cargando depósitos...
                </MenuItem>
              ) : null}
              {warehouses.map((warehouse) => (
                <MenuItem key={warehouse.uuid} value={warehouse.uuid}>
                  {warehouse.name || warehouse.code}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
        )}

        <Grid item xs={12} md={providerOnly ? 6 : 4}>
          <CustomSelect
            label="Depósito destino (recepción)"
            name="uuid_destination_warehouse"
            value={selectedOrder.uuid_destination_warehouse}
            onChange={onSelectChange}
            disabled={warehousesLoading}
            fullWidth
          >
            {warehousesLoading ? (
              <MenuItem value="" disabled>
                Cargando depósitos...
              </MenuItem>
            ) : null}
            {warehouses.map((warehouse) => (
              <MenuItem key={warehouse.uuid} value={warehouse.uuid}>
                {warehouse.name || warehouse.code}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>

        <Grid item xs={12} md={4}>
          <CustomTextField
            label="Fecha requerida"
            name="required_at"
            type="date"
            value={selectedOrder.required_at}
            onChange={onInputChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        {isProviderSource && (
          <Grid item xs={12} md={4}>
            <CustomTextField
              label="Compromiso proveedor"
              name="provider_delivery_commitment_at"
              type="date"
              value={selectedOrder.provider_delivery_commitment_at}
              onChange={onInputChange}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
        )}

        <Grid item xs={12} md={4}>
          <CustomTextField
            label="Lugar de entrega"
            name="delivery_place"
            value={selectedOrder.delivery_place}
            onChange={onInputChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <CustomTextField
            label="Contacto de entrega"
            name="delivery_contact_name"
            value={selectedOrder.delivery_contact_name}
            onChange={onInputChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <CustomTextField
            label="Teléfono de contacto"
            name="delivery_contact_phone"
            value={selectedOrder.delivery_contact_phone}
            onChange={onInputChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <CustomTextField
            label="Condiciones"
            name="conditions"
            value={selectedOrder.conditions}
            onChange={onInputChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <CustomTextField
            label="Observaciones"
            name="observations"
            value={selectedOrder.observations}
            onChange={onInputChange}
            multiline
            minRows={isMobile ? 2 : 3}
            fullWidth
          />
        </Grid>
      </Grid>

      <SupplyOrderMaterialsSection
        materials={selectedOrder.materials}
        searchEnabled={searchEnabled}
        onAddMaterial={onAddMaterial}
        onUpdateMaterialQuantity={onUpdateMaterialQuantity}
        onRemoveMaterial={onRemoveMaterial}
      />
    </Box>
  );
};

export default SupplyOrderFormSection;
